module.exports = __webpack_public_path__ + "static/media/7.22.7f8c84c9.png";